<template>
    <div
        class="flex flex-col items-center justify-center flex-grow w-full mx-10"
    >
        <component
            ref="itmo"
            v-for="(itmo, index) in ITMOCards"
            :key="itmo.key"
            :is="itmo.model"
            :data="itmo.object"
            v-on:remove="removeHardware($event, index)"
        />
        <base-add-button title="Ajouter une ITMO" @click="pushArray" />
        <base-primary-button title="Suivant" @click="nextStep" />
    </div>
</template>

<script>
import ITMO from "./components/itmoCard";
import { mapState } from "vuex";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        ITMO
    },
    data() {
        return {
            ITMOCards: []
        };
    },

    mounted() {
        this.ITMOCards = this.$store.getters["EtudeTechnique/getITMO"];
    },
    mixins: [scrollToError],

    methods: {
        removeHardware(payload, index) {
            this.$store.dispatch("EtudeTechnique/removeITMO", payload);
            this.ITMOCards.splice(index, 1);
        },
        nextStep() {
            if (!this.checkForms() && this.itmoArrayLength >= 1) {
                this.$store.dispatch("EtudeTechnique/SaveITMO");
                this.$store.dispatch(
                    "forms/subStepComplete",
                    "Moyens d’exploitation"
                );
                this.$router.push({
                    name: "moyens_humains",
                    params: { uid: `${this.$store.state.user.bpiId}` }
                });
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        pushArray() {
            if (!this.checkForms()) {
                this.ITMOCards.push({
                    model: "ITMO",
                    key:
                        new Date().getTime() +
                        String.fromCharCode(
                            65 + Math.floor(Math.random() * 26)
                        ),
                    object: {
                        id:
                            new Date().getTime() +
                            String.fromCharCode(
                                65 + Math.floor(Math.random() * 26)
                            ),
                        image: null,
                        designation: "",
                        nombre: 1,
                        caracteristique: "",
                        etat: "",
                        prix: null,
                        nomFournisseur: "",
                        origine: ""
                    }
                });
                this.$refs.itmo[this.$refs.itmo.length - 1].scrollToRef();
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        checkForms() {
            let formsHasError = false;
            this.$refs.itmo.forEach(item => {
                if (!item.addTechHardware()) {
                    formsHasError = true;
                }
            });
            return formsHasError;
        }
    },
    computed: {
        ...mapState("EtudeTechnique", {
            itmoArrayLength: state => state.itmo.length
        })
    }
};
</script>

<style></style>
